export default "__VITE_ASSET__0c28000c__"